<div class="fab-container">
  <button mat-fab class="fab-toggler" aria-label="Ouvrir le menu" title="Ouvrir le menu" (click)="onToggle()">
    <div class="burger" [class.cross]="fabState === 'active'">
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
    </div>
  </button>
  <div [@speedDialStagger]="buttons.length">
    @for (btn of buttons; track btn.title) {
    <button mat-mini-fab class="fab-secondary" [color]="btn.color" (click)="btn.command && btn.command()"
      [routerLink]="btn.url" [title]="btn.title" [attr.aria-label]="btn.title">
      <mat-icon>{{ btn.icon }}</mat-icon>
    </button>
    }
  </div>
</div>
